// extracted by mini-css-extract-plugin
module.exports = {"CustomCollapse":"CustomCollapse___D5AGm","CustomPanel":"CustomPanel___2wl4Y"};